export class ItemsPerPage {
    constructor(
        public itemsPerPage?: number,
    ) { }

    clone() {
        return new ItemsPerPage(
            this.itemsPerPage
        );
    }
}
